import { motion } from "framer-motion";
import { ReactNode } from "react";

export interface FeatureItem {
    title: string;
    description: string;
    icon: ReactNode;
    colSpan: string;
    bg: string;
}

interface LandingFeaturesProps {
    title: string;
    subtitle: string;
    features: FeatureItem[];
}

export const LandingFeatures = ({ title, subtitle, features }: LandingFeaturesProps) => {
    return (
        <section className="py-24 bg-white dark:bg-gray-900 transition-colors duration-300">
            <div className="container mx-auto px-4 max-w-6xl">
                <div className="mb-16 text-center">
                    <h2 className="text-3xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white">{title}</h2>
                    <p className="text-gray-600 dark:text-gray-400 text-lg">{subtitle}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {features.map((feature, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 }}
                            viewport={{ once: true }}
                            className={`p-8 rounded-2xl border backdrop-blur-sm hover:bg-opacity-80 transition-all duration-300 group ${feature.colSpan} ${feature.bg}`}
                        >
                            <div className="mb-4 text-gray-400 group-hover:text-gray-600 dark:text-gray-300 dark:group-hover:text-white transition-colors">{feature.icon}</div>
                            <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">{feature.title}</h3>
                            <p className="text-gray-600 dark:text-gray-400 group-hover:text-gray-800 dark:group-hover:text-gray-300 transition-colors">{feature.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
